import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FavoriteIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FavoriteIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M12.5363 21C11.9733 21 11.4122 20.8329 10.9328 20.5006L4.25285 15.6093C3.18431 14.8675 2.54004 13.639 2.54004 12.3304V9.35068C2.54004 7.84857 3.30194 6.367 4.62986 5.28709C5.48627 4.59126 6.51789 4.15832 7.61448 4.03616C7.79659 4.01173 8.23562 4 8.26072 4C9.90216 4 11.4585 4.70169 12.5398 5.90474C13.6216 4.70169 15.1779 4 16.8194 4C16.844 4 17.283 4.01173 17.4759 4.03812C18.5617 4.15833 19.5948 4.59126 20.4507 5.28807C21.7786 6.36798 22.54 7.8476 22.54 9.34579V12.3304C22.54 13.6381 21.8958 14.8665 20.8164 15.6171L14.1571 20.4928C13.6698 20.8309 13.1024 21 12.5363 21ZM8.26072 5.00076C8.22725 5.00076 7.88962 5.00857 7.73851 5.0291C6.82402 5.13171 5.97402 5.48745 5.26871 6.06112C4.17507 6.95045 3.54803 8.14959 3.54803 9.35068V12.3304C3.54803 13.3126 4.03135 14.2342 4.841 14.7962L11.5209 19.6875C12.1263 20.1077 12.9537 20.1077 13.5689 19.6797L20.2282 14.804C21.0487 14.2342 21.532 13.3117 21.532 12.3305V9.34581C21.532 8.14863 20.905 6.95144 19.8118 6.06211C19.1065 5.48844 18.256 5.13172 17.3519 5.03107C17.189 5.00859 16.8523 5.00078 16.8154 5.00078C15.2837 5.00078 13.8377 5.74645 12.9517 6.99641C12.8577 7.12932 12.7037 7.20848 12.5398 7.20848C12.3759 7.20848 12.2218 7.12932 12.1273 6.99641C11.2424 5.74645 9.79684 5.00076 8.26072 5.00076Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FavoriteIcon;
